const PREFIX = 'ICLUD_AI_'
export const REFRESH_TOKEN = `${PREFIX}REFRESH_TOKEN`
export const TOKEN = `${PREFIX}TOKEN`
export const LAST_REFRESH_TOKEN_TIMESTAMP = `${PREFIX}LAST_REFRESH_TOKEN_TIMESTAMP`
export const IS_AUTH = `${PREFIX}IS_AUTH`
export const TOKEN_EXPIRES_TIME = `${PREFIX}TOKEN_EXPIRES_TIME`

export const USER_EMAIL = `${PREFIX}USER_EMAIL`
export const USER_INFO = `${PREFIX}USER_INFO`
export const ACCOUNT_INFO = `${PREFIX}ACCOUNT_INFO`
export const USER_SETTINGS = `${PREFIX}USER_SETTINGS`
